/*
Extrusion Pulls
  --length | length of the pieces that are ordered
*/
import hardwareFilters from '@/modules/standardItems/schemas/hardware/filters'

export default [
  ...hardwareFilters,
  {
    label: 'Length',
    value: 'length',
    type: 'list'
  }
]
